import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { OrganizationsService } from '../../../services/organizations.service';
import { getCategoryOptionsUtil } from '../../../utils/getCategoryOptions.util';

@Component({
  selector: 'app-create-organization',
  templateUrl: './create-organization.component.html',
  styleUrls: ['./create-organization.component.scss'],
})
export class CreateOrganizationComponent implements OnChanges {
  @Input() public organizations: any[] = [];
  @Input() public categories: any[] = [];
  @Input() public users: any[] = [];
  @Input() public prefill: any;

  @Output() update = new EventEmitter();

  public innerForm = this.formBuilder.group({
    organization_id: [''],
    organization_name: ['', Validators.required],
    organization_description: ['', Validators.required],
    categories: [[], Validators.required],
    users: [[], Validators.required],
    organization_cover_photo: [null],
  });

  public categoryOptions: any;
  public userOptions: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private organizationsService: OrganizationsService,
    private notifications: NotificationsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users']?.currentValue) {
      this.userOptions = this.users.map((user) => {
        return {
          itemName: `${user.first_name} ${user.last_name}`,
          id: user.id,
        };
      });
    }

    if (changes['categories']?.currentValue?.length) {
      this.categoryOptions = getCategoryOptionsUtil(this.categories);
    }

    if (changes['prefill']?.currentValue) {
      const organization = changes['prefill'].currentValue;
      this.innerForm.patchValue(organization);
      this.innerForm
        .get('organization_cover_photo')
        ?.setValue(organization.files?.logo ?? null);
    }
  }

  submit(): void {
    const data = { ...this.innerForm.value };

    delete data.organization_cover_photo;

    this.organizationsService.saveUpdateOrganization(data).subscribe((res) => {
      const file = this.innerForm.get('organization_cover_photo')?.value;

      if (file instanceof File) {
        this.organizationsService
          .updateLogo(file, res.organization.organization_id)
          .subscribe(() => {
            this.saveSuccessful();
          });
      } else {
        this.saveSuccessful();
      }
    });
  }

  saveSuccessful(): void {
    this.notifications.success(
      'Success!',
      `Organization ${this.innerForm.value.organization_name} was successfully created`
    );
    this.innerForm.reset();
    this.update.emit();
  }
}
